
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { Settings } from 'lucide-react';

interface AdvancedTabContentProps {
  editing: boolean;
}

const AdvancedTabContent: React.FC<AdvancedTabContentProps> = ({ editing }) => {
  return (
    <div className="grid gap-4">
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="enable-logging">Enable AI Interaction Logging</Label>
          <p className="text-sm text-muted-foreground">Record AI interactions for audit and improvement</p>
        </div>
        <Switch 
          id="enable-logging" 
          checked={true} 
          disabled={!editing}
        />
      </div>
      
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="enable-fallback">Enable Fallback Model</Label>
          <p className="text-sm text-muted-foreground">Use a backup model when primary model fails</p>
        </div>
        <Switch 
          id="enable-fallback" 
          checked={false} 
          disabled={!editing}
        />
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="token-limit">Max Token Limit</Label>
        <Input 
          id="token-limit" 
          type="number"
          placeholder="4000" 
          disabled={!editing}
          defaultValue="4000"
        />
        <p className="text-xs text-muted-foreground">
          Maximum tokens to use per API request
        </p>
      </div>
    </div>
  );
};

export default AdvancedTabContent;
